export default __webpack_public_path__ + "static/mock-reward-4-74afb89b683f821bbb132098c846f6f6.webp";